export const DeviceShipping = {
    uuid: "",
    uid: "",
    model: "",
    device_id: "",
    group_device_id: 0,
    group_device_name: "",
    group_asset_id: 0,
    group_asset_name: "",
    island_id: 0,
    island_name: "",
    config_id: 0,
    config_name: "",
    full_address: null,
    carry_ship: true,
    carry_sensors: true,
    carry_alerts: true,
    ship_send: false,
    ship_ack: false,
    ship_cc_at: null,
    sensors_send: false,
    sensors_ack: false,
    sensors_cc_at: null,
    alerts_send: false,
    alerts_ack: false,
    alerts_cc_at: null,
    updated_at: "",
    state:false
}